import React, { Fragment } from 'react'
import styled from '@emotion/styled'
import { InfoTooltip } from 'components/Tooltip'
import { SubHeading } from 'components/Text'
import { ResponsiveContainer } from 'components/Container'
import { GrowCol } from 'components/Col'
import { BlueInfo } from 'components/Icon'
import { spacer, Form } from 'stylist'
import EstimateInput from './EstimateInput'
import PiiInput from './PiiInput'
import EstimateLocale from './EstimateLocale'

const DualInputs = styled.div`
  display: flex;
`

const Info = styled(BlueInfo)`
  margin-left: ${spacer(2)};
`

const Grow = styled(GrowCol)`
  margin-top: ${spacer(5)};
`

const aboutSurveyTooltipContent = `
    <div>
      <h1>Length of Survey</h1>
      <p>How many minutes will it take someone to successfully complete your full survey? Estimate the average
        time you believe it will take people to fully complete the survey in one sitting. Pre-testing your
        survey with a few people is a good way to estimate the time it will take to complete it.
      </p>
      <h1>Qualifying Rate</h1>
      <p>What percentage of people in the population will qualify (<em>or meet the desired criteria</em>) 
        for your survey? A survey targeting a hard to reach audience (e.g. business owners) will have a low qualifying 
        rate or incidence. A survey where the audience is easy to reach will have a high qualifying rate. This number is
        reflected as a percentage. Industry reports or other population statistics
        (e.g. <a href="https://www.census.gov/en.html" target="_blank">U.S. Census</a>) can help you estimate
        the qualifying rate.
      </p>
      <p>Example: If you send a survey to 1,000 people in the Unified States and your survey only accepts cat
        owners, you might estimate that 30% of people will qualify for your survey based on a recent report from
        the American Veterinary Medical Association.
      </p>
    </div>
`

const piiTooltipContent = `
  <div>
    <p>Are you collecting emails, full names, addresses or phone numbers? Collecting information that can be used to 
      distinguish or trace an individual's identity is considered personally identifying information or PII.
    </p>

    <p>Some vendors and countries do not allow for this type of data collection. 
      If you indicate that you are collecting PII, please be aware your bid results may be more limited.
    </p>
  </div>
`

const EstimateGrid = () => (
  <Fragment>
    <ResponsiveContainer>
      <Grow>
        <SubHeading>How many qualified participants do you need?</SubHeading>
        <EstimateInput name="completions" unit="Participants" />
      </Grow>
      <Grow>
        <SubHeading>How long will your survey be live?</SubHeading>
        <EstimateInput name="fieldLength" unit="Days" />
      </Grow>
    </ResponsiveContainer>
    <ResponsiveContainer>
      <Grow>
        <SubHeading>
          Tell us about your survey.
          <InfoTooltip
            id="info-tell-us-about"
            contents={aboutSurveyTooltipContent}
          />
        </SubHeading>
        <DualInputs>
          <EstimateInput
            label="Length of Survey"
            name="interviewLength"
            unit="Min"
          />
          <EstimateInput label="Qualifying Rate" name="incidence" unit="%" />
        </DualInputs>
      </Grow>
      <Grow>
        <SubHeading>
          Does your survey collect personally identifying information?
          <InfoTooltip id="info-collect-pii" contents={piiTooltipContent} />
        </SubHeading>
        <PiiInput />
      </Grow>
    </ResponsiveContainer>
    <ResponsiveContainer>
      <Grow>
        <SubHeading>What is the locale of your audience?</SubHeading>
        <EstimateLocale />
      </Grow>
    </ResponsiveContainer>
  </Fragment>
)

export default EstimateGrid



// WEBPACK FOOTER //
// ./src/routes/estimate/subroutes/form/EstimateGrid.js